import { isLongText } from "./isLongText";

function executeOnce(fn: Function) {
  let executed = false;
  return function (..._args: any) {
    if (!executed) {
      executed = true;
      // @ts-ignore
      fn.apply(this, arguments);
    }
  };
}

export default function slideDistance({ end = 0, speed = 0.015, minDistance = 4 }: any = {}) {
  const { isRtl } = useLanguage();
  const direction = isRtl ? 1 : -1;
  return executeOnce((element: any) => {
    if (!element || end >= 0) return;

    const target = Math.abs(end);
    if (target <= minDistance) return;

    if (isLongText()) {
      let animationId: number;
      let delayTimer1: NodeJS.Timeout; // 动画前暂停
      let delayTimer2: NodeJS.Timeout; // 到达终点后暂停
      let delayTimer3: NodeJS.Timeout; // 跳回原点后暂停
      // 修改后的常量定义
      const PRE_ANIMATION_DELAY = 2000; // 动画开始前的延迟时间
      const POST_ANIMATION_DELAY = 2000; // 动画完成后的延迟时间
      // 清理函数
      function clearupAnimation() {
        clearTimeout(delayTimer1);
        clearTimeout(delayTimer2);
        clearTimeout(delayTimer3);
        cancelAnimationFrame(animationId);
      }
      const runAnimationCycle = () => {
        clearupAnimation();
        // 阶段1: 动画前暂停1秒
        delayTimer1 = setTimeout(() => {
          let startTime = Date.now();
          let distance = 0;

          const animateForward = () => {
            const currentTime = Date.now();
            const elapsed = currentTime - startTime;

            // 前进动画
            distance = Math.min(distance + speed * elapsed, target);
            element.style.transform = `translateX(${distance * direction}px)`;

            if (distance >= target) {
              // 阶段2: 到达终点后暂停1秒
              delayTimer2 = setTimeout(() => {
                // 阶段3: 跳回原点
                distance = 0;
                element.style.transform = `translateX(${distance * direction}px)`;

                // 阶段4: 跳回原点后暂停1秒
                delayTimer3 = setTimeout(() => {
                  runAnimationCycle(); // 重新开始循环
                }, PRE_ANIMATION_DELAY);
              }, POST_ANIMATION_DELAY);
              return;
            }

            startTime = currentTime;
            animationId = requestAnimationFrame(animateForward);
          };

          animateForward();
        }, PRE_ANIMATION_DELAY);
      };

      // 首次启动动画循环
      runAnimationCycle();
      return clearupAnimation;
    } else {
      // 原始动画逻辑（非俄罗斯语言）

      let startTime = Date.now();
      let distance = 0;
      let animationFrameId: number;

      const animate = () => {
        const currentTime = Date.now();
        const elapsed = currentTime - startTime;

        // 更新距离
        distance = Math.min(distance + speed * elapsed, target);
        element.style.transform = `translateX(${distance * direction}px)`;

        // 重置或继续动画
        if (distance >= target) {
          distance = 0; // 重置位置
          startTime = currentTime; // 重置计时器
        }

        animationFrameId = requestAnimationFrame(animate);
        startTime = currentTime;
      };

      // 启动动画
      animationFrameId = requestAnimationFrame(animate);

      // 返回清理函数
      return () => cancelAnimationFrame(animationFrameId);
    }
  });
}
